import { useMemo } from 'react';
import { z } from 'zod';

import { getMetaField } from '../meta-field';
import { validationErrors } from '../validation-errors';

const { getRequiredMessage, getFormatMessage } = validationErrors;

export const useValidationRec = () => {
	const metaField = useMemo(() => getMetaField(), []);

	const passRecoverySchema = z.object({
		email: z
			.string()
			.email(getFormatMessage(metaField.email.label))
			.trim()
			.min(1, getRequiredMessage(metaField.email.label)),
	});
	return { passRecoverySchema };
};

export type PassRecovery = z.infer<ReturnType<typeof useValidationRec>['passRecoverySchema']>;
